export const constructContactOptions = (contactOptions, user) => {
  return contactOptions.map((option) => {
    let value;
    if (option.option === 'email') {
      value = user?.emails[0]?.address;
    } else if (option.option === 'call') {
      value = user?.profile?.contactnumber;
    } else if (option.option === 'whatsapp') {
      value = user?.profile?.whatsappNumber;
    }

    return {
      option: option.option,
      value: value || '',
      enabled: !!value,
    };
  });
};
